<template>
  <div class="mt-5">
    <b-container>
      <b-row class="justify-content-center">
        <div class="col-md-8">
          <b-card class="transaction-card">
            <b-card-body>
              <div class="text-center" v-if="isLoading">
                <b-skeleton class="mb-3" type="avatar"></b-skeleton>
                <b-skeleton></b-skeleton>
                <b-skeleton></b-skeleton>
                <b-skeleton></b-skeleton>
              </div>
              <div v-else>
                <div class="text-center mb-5">
                  <b-icon class="mb-2" :icon="getIcon" :class="getStatusClass" font-scale="4"></b-icon>
                  <h1 class="font-weight-bolder text-capitalize" :class="getStatusClass">{{ status }}</h1>
                </div>
                <div class="mb-5 p-4 bg-light rounded">
                  <div class="mb-3">
                    <strong>Subscription Plan:</strong> <span class="text-muted">{{ subscriptionPlan }}</span>
                  </div>
                  <div class="mb-3">
                    <strong>Amount:</strong> <span class="text-muted">{{ amount }}</span>
                  </div>
                  <div class="">
                    <strong>Transaction ID:</strong> <span class="text-muted">{{ transactionID }}</span>
                  </div>
                </div>
                <div class="mb-2">
                  <router-link v-if="status === 'failed'" to="/subscription-plans" class="btn btn-primary btn-block rounded-pill">Retry</router-link>
                  <router-link v-else to="/" class="btn btn-primary btn-block rounded-pill">Go to Dashboard</router-link>
                </div>
                <div class="text-muted countdown small">Redirecting in {{ countdown }} seconds...</div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import b2bService from "../api/b2b-service";

export default {
  name: "TransactionDetails",
  data() {
    return {
      subscriptionPlan: '-',
      transactionID: '-',
      amount: '-',
      status: '-',
      countdown: 5,
      isLoading: false,
    };
  },
  computed: {
    getIcon() {
      if (this.status === 'success') {
        return 'check-circle-fill';
      } else if (this.status === 'failed') {
        return 'exclamation-circle-fill';
      } else if (this.status === 'pending') {
        return 'clock-fill';
      }
      return '';
    },
    getIconVariant() {
      if (this.status === 'success') {
        return 'success';
      } else if (this.status === 'failed') {
        return 'danger';
      } else if (this.status === 'pending') {
        return 'warning';
      }
      return '';
    },
    getStatusClass() {
      if (this.status === 'success') {
        return 'status success';
      } else if (this.status === 'failed') {
        return 'status failed';
      } else if (this.status === 'pending') {
        return 'status pending';
      }
      return 'status';
    }
  },
  methods: {
    startCountdown() {
      const intervalId = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(intervalId);
          this.redirectToHome();
        }
      }, 1000);
    },
    redirectToHome() {
      this.$router.push('/');
    }
  },
  created() {
    this.transactionID = this.$route.params.id;
    this.status = this.$route.params.status;
  },
  mounted() {
    this.isLoading = true;
    b2bService.getTransactionDetails(this.transactionID).then((resp) => {
      const data = resp.data;
      this.amount = `${data.currency.toString().toUpperCase()} ${data.amount}/-`;
      this.subscriptionPlan = data.subscriptionName;
      this.startCountdown();
    }).catch((e) => {
      this.$router.push('/');
    }).finally(() => {
      this.isLoading = false;
    });
  }
};
</script>

<style scoped>
h1 {
  font-size: 4rem;
}

.transaction-card {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 20px;
  border: none;
}

.status.success {
  color: #73bc44;
}

.status.failed {
  color: #dc3545;
}

.status.pending {
  color: #ffc107;
}

.btn-primary {
  color: #fff;
  background-color: #73bc44 !important;
  border: none;
  padding-top: 15px;
  padding-bottom: 15px;
}

.btn-primary:hover {
  color: #fff;
  background-color: #73bc44 !important;
  border-color: #73bc44 !important;
}
</style>
